import { styled } from 'styled-components';

export const RadioGroupWrapper = styled.div`
    & > div {
        display: block;
    }
    & > div > div {
        padding-left: 16px;
        margin: 0;
        align-items: center;

        &:not(:last-child) {
            border-bottom: 1px solid #ecece6;
        }
        label {
            font-size: 16px;
            padding: 21px 12px;
            width: 100%;
        }
    }
    & > div > div > div {
        align-self: center;
    }
`;
